<template>
  <div
      class="hidden lg:block max-w-max mt-10 right-10 z-10"
      :class="scrollPosition >= 575 ? 'fixed top-12' : 'absolute mt-10'"
  >
    <ul class="space-y-3">
      <li v-for="(item, index) in list" :key="index" :ref="`item_${index}`">
        <div
            @click="scrollToElement(item.target)"
            class="block cursor-pointer py-1 px-3 lowercase rounded text-center"
            :class="getItemCSSClasses(item, index)"
        >
          {{ item.title }}
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: "OurStoryTabs",
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentFocusedElement: this.list[0].target,
      scrollPosition: 0,
      swappedColors: []
    }
  },
  methods: {
    isOurStoryBlockScrolledInViewport(el) {
      const rect = el.getBoundingClientRect();

      return rect.top <= ((window.innerHeight || document.documentElement.clientHeight) - 200);
    },
    isItemHoveringAboveVideoElement(element) {
      const videoElement        = document.getElementById('sectionfive');
      const offsetTopElement    = element.offsetTop + window.scrollY + 75;
      const offsetBottomElement = element.offsetHeight + offsetTopElement;

      videoElement.offsetBottom = videoElement.offsetTop + videoElement.offsetHeight;

      return !((offsetBottomElement <= videoElement.offsetTop) ||
          (offsetTopElement >= videoElement.offsetBottom));
    },
    handleScrollEvent() {
      this.scrollPosition = window.scrollY;

      this.list.forEach((item, index) => {
        if (this.isOurStoryBlockScrolledInViewport(document.getElementById(item.target.substring(1)))) {
          this.currentFocusedElement = item.target;
        }

        if (this.isItemHoveringAboveVideoElement(this.$refs[`item_${index}`][0])) {
          if (! this.swappedColors.includes(index)) {
            this.swappedColors.push(index);
          }
        } else {
          const swappedColorsIndex = this.swappedColors.indexOf(index);

          if (swappedColorsIndex > -1) {
            this.swappedColors.splice(swappedColorsIndex, 1);
          }
        }
      })
    },
    getItemCSSClasses(item, index) {
      if (this.swappedColors.includes(index)) {
        return this.currentFocusedElement === item.target ? 'bg-white text-blue-500' : 'border-2 border-white text-white';
      }

      return this.currentFocusedElement === item.target ? 'bg-blue-500 text-white' : 'border-2 border-blue-500 text-blue-500';
    },
    scrollToElement(target) {
      const config = {
        easing: 'ease-in-out',
        offset: -120,
        cancelable: true
      };

      VueScrollTo.scrollTo(target, 500, config);
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScrollEvent);
    this.handleScrollEvent();
  }
}
</script>